export const MENU_ID = 'user';
